module.exports = __webpack_public_path__ + "media/images/mail_template/rss-6b0b2f1ee7206c01a2bec733c1a4f1b1.png";